import React from 'react';
import { SvgProps } from '../../interfaces/svg';

const ArrowLeft = ({
  width = '24',
  height = '24',
  color = '#75797E',
  className = 'arrow-left',
}: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    enableBackground="new 0 0 24 24"
    className={className}
  >
    <g>
      <path fill="none" d="M0,0h24v24H0V0z" />
    </g>
    <g>
      <path
        fill={color}
        d="M15.41,16.59L10.83,12l4.58-4.59L14,6l-6,6l6,6L15.41,16.59z"
      />
    </g>
  </svg>
);

export default ArrowLeft;
